import React, { useContext, useEffect } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useSelector, useDispatch } from 'react-redux';
// eslint-disable-next-line import/no-cycle
import CardItem from './CardItem';
import { Context } from './ContextWrapper';
import { getCostingStageList } from '../Store/SystemMasters.action';

function CardContent() {
  const { cards } = useContext(Context);
  const dispatch = useDispatch();
  const csList = useSelector((state) => state);
  const {
    UserDetails: { userInfo },
  } = csList;

  useEffect(() => {
    if (userInfo.userId) {
      dispatch(getCostingStageList({ loggedInUserId: userInfo.userId }));
    }
  }, [dispatch, userInfo]);

  return (
    <PerfectScrollbar>
      <ul>
        {cards.map((card, index) => (
          <CardItem key={card?._id || index} index={index} item={card} />
        ))}
      </ul>
    </PerfectScrollbar>
  );
}

export default CardContent;
